import React, { useEffect, useCallback, useState } from 'react';
import { Table, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import ConfigHeading from '../../configure/components/ConfigHeading';
import EditConfirmingPackage from './EditConfirmingPackage';
import { requestUnconfirmedPurchases, requestFailPurchase } from '../../../../state/ui/purchase/purchaseCreditsUiActions';
import { selectUnconfirmedPurchasesRequest, selectFailPurchaseRequest } from '../../../../state/ui/purchase/purchaseCreditsUiReducer';
import { selectPurchaseHistory } from '../../../../state/domain/purchases/purchaseHistoryReducer';
import '../bynx.css';
import PurchasesTable from '../../purchase/PurchasesTable';
import ConfirmButton from '../../../../components/buttons/ConfirmButton';


/**
 * A component allowing a bynx admin user to look up a user and retrive the purchase history for their usergroup
 */
export default function UnconfirmedPurchases() {
  // Redux Actions
  const dispatch = useDispatch();
  const loadPageData = useCallback(() => { dispatch(requestUnconfirmedPurchases()); }, [dispatch]);
  const failPurchase = purchase => dispatch(requestFailPurchase(purchase.code));

  // Redux State
  const pageDataRequest = useSelector(selectUnconfirmedPurchasesRequest);
  const isLoading = !!(pageDataRequest && pageDataRequest.isLoading);
  const purchases = useSelector(selectPurchaseHistory);
  const failPurchaseRequest = useSelector(selectFailPurchaseRequest);
  const failRequestLoading = (failPurchaseRequest && failPurchaseRequest.isLoading);

  // React State
  const [updatingPackage, setUpdatingPackage] = useState();


  // Load
  useEffect(() => {
    loadPageData();
  }, [loadPageData]);

  return (
    <div className="via-layout-configure-main">
      <ConfigHeading titleId="unconfirmedSales" descriptionId="unconfirmedSalesDesc">
        <PurchasesTable
          isLoading={isLoading}
          purchases={purchases}
          includeCompanyName
          editColumn={(
            <Table.Column
              className="via-action-column"
              align="center"
              render={(text, record) => {
                if (record.purchaseStatus !== 'CONFIRMING') return undefined;
                return (
                  <div className="button-flex-col">
                    <ConfirmButton icon="stop" size="small" type="danger" loading={failRequestLoading} onClick={() => failPurchase(record)}>
                      <FormattedMessage id="fail" />
                    </ConfirmButton>
                    <Button icon="edit" size="small" type="primary" onClick={() => setUpdatingPackage(record)}>
                      <FormattedMessage id="update" />
                    </Button>
                  </div>
                );
              }}
            />
          )}
        />
        <EditConfirmingPackage
          confirmingPackage={updatingPackage}
          visible={!!updatingPackage}
          onCancel={() => setUpdatingPackage()}
        />
      </ConfigHeading>
    </div>
  );
}
